import type { QueryClient } from "@tanstack/react-query";

import { API_PATHS } from "@shared/platform/app-metadata";

export type CachedIdentity = { userId: number; role: string } | null | undefined;

export function identityOf(user: { id: number; role: string } | null | undefined): CachedIdentity {
  return user ? { userId: user.id, role: user.role } : user;
}

export function shouldDropCachedData(previous: CachedIdentity, next: CachedIdentity): boolean {
  if (!previous || next === undefined) return false;
  return next === null || previous.userId !== next.userId || previous.role !== next.role;
}

export function dropCachedDataExceptUser(client: QueryClient): void {
  client.removeQueries({ predicate: (query) => query.queryKey[0] !== API_PATHS.user });
}
